module.exports = __webpack_public_path__ + "img/img5.1c734969.jpg";